import Vue from 'vue'
import PrismicVue from 'prismic-vue'
import linkResolver from './prismic/link-resolver.coffee'
import htmlSerializer from './prismic/html-serializer.coffee'
import App from './App.vue'
import router from './router.coffee'
import prismicComponent from '@/mixins/prismicComponent.coffee'

import 'typeface-roboto'

Vue.config.productionTip = false

#accessToken = 'MC5XLTRLQlJBQUFDTUFqcDFi.77-977-9Fe-_vQLvv73vv70g77-977-977-977-977-977-9Uu-_vSrvv71W77-9YDrvv73vv70f77-977-977-9IDwHXw'

Pace.on 'done', -> 
    window.prerenderReady = true 
    console.log 'pace is done'

Vue.use PrismicVue, {
    endpoint: window.prismic.endpoint,
    linkResolver,
    htmlSerializer,
    apiOptions: {
#        accessToken
    }
}

Vue.mixin prismicComponent

new Vue({
  router,
  render: (h) -> h App
}).$mount '#app'
